const statuses = { 1: "New", 2: "Cancel", 3: "Closed", 4: "Ongoing", 5: "Claim" };
const pending = { 1: "Purchase Contract", 2: "Sales Contract", 3: "Advance Payment", 4: "Shipment Schedule", 5: "Document Pending", 6: "Final Payment Pending", 7: "Container Release" };
const valueFor = (row, key) => {
  if (key === "DealID") return row.DealNo || row.DealID;
  if (key === "Price") return row.FixedAmount ?? null;
  if (key === "PriceMode") {
    const mode = String(row.PriceMode || "").replace(/\s+/g, "").toLowerCase();
    if (mode === "fixed") return "Fixed";
    if (mode === "unfixed") return "Unfixed";
    if (row.FixedAmount !== null && row.FixedAmount !== undefined && (row.UnFixedAmount === null || row.UnFixedAmount === undefined)) return "Fixed";
    if (row.UnFixedAmount !== null && row.UnFixedAmount !== undefined && (row.FixedAmount === null || row.FixedAmount === undefined)) return "Unfixed";
    return "";
  }
  if (key === "DealStatus") return statuses[row.DealStatus] || "";
  if (key === "PendingStatus") return Number(row.PendingStatus) === 4 && row.ContainerNo ? "Container Detail Pending" : pending[row.PendingStatus] || "";
  return row[key];
};

export const sortDeals = (rows, key, direction) => {
  if (!key) return rows;
  const numeric = ["NoOfContainer", "Price", "TotalQty"].includes(key);
  return [...rows].sort((a, b) => {
    const av = valueFor(a, key), bv = valueFor(b, key);
    const emptyA = av === null || av === undefined || av === "";
    const emptyB = bv === null || bv === undefined || bv === "";
    if (emptyA || emptyB) return emptyA === emptyB ? 0 : emptyA ? 1 : -1;
    const order = numeric ? Number(av) - Number(bv)
      : key === "DealDate" ? new Date(av).getTime() - new Date(bv).getTime()
      : String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: "base" });
    return direction === "desc" ? -order : order;
  });
};
